/**
 * Shop by Category (shop-by-category.js): refresh Swiper when slides are hidden
 * on mobile (per-block "Hide on mobile") so slide widths and navigation stay correct.
 * Uses slidesPerView: "auto" so per-block column counts control width via CSS (cqw).
 * Hero tablet-portrait still forces slidesPerView: 1 (full-width).
 */
(function () {
  var HERO_PORTRAIT_MQ = '(min-width: 900px) and (max-width: 1024px) and (orientation: portrait)';

  function getSectionRoot(host) {
    return (
      (host && host.closest && host.closest('.am-collection-list')) ||
      document.querySelector('.am-collection-list-section .am-collection-list')
    );
  }

  function desiredSlidesPerView(root) {
    var isHero = !!(root && root.classList.contains('am-collection-list--hero'));
    if (isHero && window.matchMedia(HERO_PORTRAIT_MQ).matches) return 1;
    return 'auto';
  }

  function clearInlineSlideWidths(swiper) {
    if (!swiper || !swiper.slides) return;
    /* Let CSS (cqw) own width; Swiper may stamp equal px widths when params flip. */
    swiper.slides.forEach(function (slide) {
      if (slide && slide.style) {
        slide.style.removeProperty('width');
      }
    });
  }

  function syncSwiperSlidesPerView(host) {
    if (!host || !host.swiper) return;
    var root = getSectionRoot(host);
    if (!root) return;
    var spv = desiredSlidesPerView(root);
    var swiper = host.swiper;
    var group = 1;
    swiper.params.slidesPerView = spv;
    swiper.params.slidesPerGroup = group;
    if (swiper.params.breakpoints) {
      Object.keys(swiper.params.breakpoints).forEach(function (key) {
        var bp = swiper.params.breakpoints[key];
        if (!bp) return;
        bp.slidesPerView = Number(key) >= 900 ? desiredSlidesPerView(root) : 'auto';
        bp.slidesPerGroup = 1;
      });
    }
    if (spv === 'auto') {
      clearInlineSlideWidths(swiper);
    }
    swiper.update();
  }

  function refreshSwipers() {
    document.querySelectorAll('.am-collection-list-section slideshow-section').forEach(function (host) {
      try {
        syncSwiperSlidesPerView(host);
        if (host.swiper && typeof host.swiper.update === 'function') {
          host.swiper.update();
        }
      } catch (e) {
        /* ignore */
      }
    });
  }

  var resizeTimer;
  var lastResizeWidth = window.innerWidth;
  function onResize() {
    /* URL-bar show/hide fires resize with the same width — skip Swiper remeasure. */
    var w = window.innerWidth;
    if (w === lastResizeWidth) return;
    lastResizeWidth = w;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(refreshSwipers, 150);
  }

  function scheduleRefresh() {
    setTimeout(refreshSwipers, 50);
    setTimeout(refreshSwipers, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRefresh);
  } else {
    scheduleRefresh();
  }

  window.addEventListener('resize', onResize, { passive: true });
  window.addEventListener('orientationchange', function () {
    lastResizeWidth = 0;
    setTimeout(refreshSwipers, 100);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var t = event.target;
    if (t && t.classList && t.classList.contains('am-collection-list-section')) {
      scheduleRefresh();
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    var section = event.target && event.target.closest && event.target.closest('.am-collection-list-section');
    if (section) scheduleRefresh();
  });
})();
